import { FC, useEffect, useState } from 'react';
import { Button, Modal, Tag } from '@maxtropy/components';
import dayjs from 'dayjs';
import styles from './index.module.scss';
import {
  apiV2EnergyConsumptionAdminDetailPost,
  V2EnergyConsumptionAdminDetailPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import TwoDayTimeline, { TimeRange } from './Timeline';
import { formatTimeRange, PlanType, PlanTypeColor } from '../util';
import { Col, Row, Space } from 'antd';
import { isEmpty, isNil } from 'lodash-es';

type DetailProps = Exclude<V2EnergyConsumptionAdminDetailPostResponse, undefined>;
interface ExportModalProps {
  onClose: () => void;
  updateFn: () => void;
  visible: boolean;
  edit?: any;
}

const DetailGovernModal: FC<ExportModalProps> = ({ edit, onClose, updateFn, visible }) => {
  const [data, setData] = useState<DetailProps>({});
  const [energyPlanTag, setEnergyPlanTag] = useState<DetailProps['planList']>([]);
  const [delayAppTag, setDelayAppTag] = useState<DetailProps['planList']>([]);
  const [times, setTimes] = useState<TimeRange[]>([]);

  useEffect(() => {
    apiV2EnergyConsumptionAdminDetailPost({ ...edit }).then(res => {
      setData(res);
      setEnergyPlanTag(res.planList?.filter(item => item.type === 1));
      setDelayAppTag(res.planList?.filter(item => item.type === 2));
      setTimes(
        res.planList?.map(item => ({
          start: item.startDateTime!,
          end: item.endDateTime!,
          type: item.type as PlanType,
        })) ?? []
      );
    });
  }, []);

  return (
    <Modal
      title="查看"
      open={visible}
      onCancel={onClose}
      size="large"
      footer={[
        <Button key={'cancel'} onClick={onClose}>
          关闭
        </Button>,
      ]}
    >
      <div>
        <div className={styles.timeAxisHeader}>
          <div>
            {data.ownerOrgName} {data.areaName} {dayjs(edit.day).format('YYYY-MM-DD')}
          </div>
          <Space size={16}>
            <div className={styles.iconPlan}>
              <span className={styles.squareA} style={{ background: PlanTypeColor[PlanType.ENERGY] }}></span>
              <span>用能计划</span>
            </div>
            <div className={styles.iconPlan}>
              <span className={styles.squareB} style={{ background: PlanTypeColor[PlanType.DELAY_ENERGY] }}></span>
              <span>延时用能</span>
            </div>
          </Space>
        </div>

        {/* 时间轴容器 */}
        <TwoDayTimeline ranges={times} baseTime={edit.day} />

        {/* 下方时间段标签 */}
        <Row gutter={8}>
          <Col span={16} className={styles.col}>
            <span className={styles.labelTitle}>用能计划：</span>
            <Space size={[0, 4]} wrap className={styles.tag}>
              {isEmpty(energyPlanTag)
                ? '--'
                : energyPlanTag?.map(e => (
                    <Tag border="solid" color={PlanTypeColor[e.type! as PlanType]} key={e.startDateTime}>
                      {formatTimeRange(edit.day, e?.startDateTime, e?.endDateTime)}
                    </Tag>
                  ))}
            </Space>
          </Col>
          <Col span={8}>
            <span className={styles.labelTitle}>用能计划时长：</span>
            <span style={{ color: PlanTypeColor[energyPlanTag?.[0]?.type! as PlanType] }}>
              {isNil(data?.energyUseDuration) ? '--' : data.energyUseDuration + '小时'}
            </span>
          </Col>
        </Row>
        <Row gutter={8} style={{ marginTop: 16 }}>
          <Col span={16} className={styles.col}>
            <span className={styles.labelTitle}>延时用能：</span>
            <Space size={[0, 4]} className={styles.tag}>
              {isEmpty(delayAppTag)
                ? '--'
                : delayAppTag?.map(d => (
                    <Tag border="solid" color={PlanTypeColor[d.type! as PlanType]} key={d.startDateTime}>
                      {formatTimeRange(edit.day, d?.startDateTime, d?.endDateTime)}
                    </Tag>
                  ))}
            </Space>
          </Col>
          <Col span={8}>
            <span className={styles.labelTitle}>延时用能时长：</span>
            <span style={{ color: PlanTypeColor[delayAppTag?.[0]?.type! as PlanType] }}>
              {isNil(data?.delayEnergyUseDuration) ? '--' : data.delayEnergyUseDuration + '小时'}
            </span>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default DetailGovernModal;
